import { Routes, Route } from "react-router-dom";
import Pages from "./pages";
import UserDetails from "./pages/users/details";
import UsersForm from "./pages/users/form/usersForm";
import MainContainer from "./layout/MainContainer";
import AddCategoryMain from "./pages/categories/add";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.LoginPage />} />
      <Route path="forgotpassword" element={<Pages.ForgotPasswordPage />} />
      <Route path="verifyotp" element={<Pages.VerifyOtp />} />
      <Route path="resetpassword" element={<Pages.ResetPassword />} />
      <Route path="changepassword" element={<Pages.ChangePassword />} />

      <Route
        path="/dashboard"
        element={
          <MainContainer>
            <Pages.DashBoardPage />
          </MainContainer>
        }
      />

      <Route
        path="/profile"
        element={
          <MainContainer>
            <Pages.Profile />
          </MainContainer>
        }
      />
      <Route
        path="/manage-users"
        element={
          <MainContainer>
            <Pages.ManageCustomers />
          </MainContainer>
        }
      />
      <Route
        path="/manage-users/details/:_id"
        element={
          <MainContainer>
            <UserDetails />
          </MainContainer>
        }
      />
      <Route
        path="/manage-users/usersform"
        element={
          <MainContainer>
            <UsersForm />
          </MainContainer>
        }
      />
      <Route
        path="/manage-users/usersform/:id"
        element={
          <MainContainer>
            <UsersForm />
          </MainContainer>
        }
      />
      <Route
        path="/manage-users/edit/chat"
        element={
          <MainContainer>
            <Pages.ChatDetails />
          </MainContainer>
        }
      />

      <Route
        path="/analytics"
        element={
          <MainContainer>
            <Pages.Analytics />
          </MainContainer>
        }
      />

      <Route
        path="/cms"
        element={
          <MainContainer>
            <Pages.ManageCms />
          </MainContainer>
        }
      />

      <Route
        path="/exchange-rate"
        element={
          <MainContainer>
            <Pages.ExchangeRate />
          </MainContainer>
        }
      />

      <Route
        path="/manage-notifications"
        element={
          <MainContainer>
            <Pages.ManageNotifications />
          </MainContainer>
        }
      />
      <Route
        path="/manage-notifications/add"
        element={
          <MainContainer>
            <Pages.AddNotification />
          </MainContainer>
        }
      />
      <Route
        path="/recieved-notifications"
        element={
          <MainContainer>
            <Pages.RecievedNotifications />
          </MainContainer>
        }
      />

      <Route
        path="/manage-vendors"
        element={
          <MainContainer>
            <Pages.ManageAgents />
          </MainContainer>
        }
      />
      <Route
        path="/manage-vendors/edit/:id"
        element={
          <MainContainer>
            <Pages.AddVendors />
          </MainContainer>
        }
      />
      <Route
        path="/manage-vendors/add"
        element={
          <MainContainer>
            <Pages.AddVendors />
          </MainContainer>
        }
      />
      <Route
        path="/manage-vendors/details/:_id"
        element={
          <MainContainer>
            <Pages.AgentDetail />
          </MainContainer>
        }
      />
      <Route
        path="/manage-vendors/edit/id"
        element={
          <MainContainer>
            <Pages.AddVendors />
          </MainContainer>
        }
      />

      <Route
        path="/manage-Banners"
        element={
          <MainContainer>
            <Pages.ManageBanners />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Banners/add"
        element={
          <MainContainer>
            <Pages.AddBanners />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Banners/edit/:_id"
        element={
          <MainContainer>
            <Pages.AddBanners />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Banners/details/:_id"
        element={
          <MainContainer>
            <Pages.BannersDetails />
          </MainContainer>
        }
      />

      <Route
        path="/manage-discount"
        element={
          <MainContainer>
            <Pages.ManageDiscount />
          </MainContainer>
        }
      />
      <Route
        path="/manage-discount/add"
        element={
          <MainContainer>
            <Pages.AddDiscount />
          </MainContainer>
        }
      />

      <Route
        path="/manage-discount/edit/:id"
        element={
          <MainContainer>
            <Pages.AddDiscount />
          </MainContainer>
        }
      />

      <Route
        path="/manage-discount/details/:id"
        element={
          <MainContainer>
            <Pages.DiscountDetails />
          </MainContainer>
        }
      />

      <Route
        path="/manage-categories"
        element={
          <MainContainer>
            <Pages.ManageCategory />
          </MainContainer>
        }
      />
      <Route
        path="/manage-categories-Main"
        element={
          <MainContainer>
            <AddCategoryMain />
          </MainContainer>
        }
      />
      <Route
        path="/manage-categories/add"
        element={
          <MainContainer>
            <Pages.AddCategory />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Subcategories/add"
        element={
          <MainContainer>
            <Pages.addSubCategory />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Subcategories/edit/:_id"
        element={
          <MainContainer>
            <Pages.addSubCategory />
          </MainContainer>
        }
      />

      <Route
        path="/manage-categories/edit/:_id"
        element={
          <MainContainer>
            <Pages.AddCategory />
          </MainContainer>
        }
      />

      <Route
        path="/manage-Subcategories/edit/:_id"
        element={
          <MainContainer>
            <Pages.addSubCategory />
          </MainContainer>
        }
      />
      <Route
        path="/manage-categories/sub-categories/:_id"
        element={
          <MainContainer>
            <Pages.CategoryDetails />
          </MainContainer>
        }
      />

      <Route
        path="/manage-revenue"
        element={
          <MainContainer>
            <Pages.ManageRevenue />
          </MainContainer>
        }
      />

      <Route
        path="/settings"
        element={
          <MainContainer>
            <Pages.AddSettings />
          </MainContainer>
        }
      />

      <Route
        path="/settings/add"
        element={
          <MainContainer>
            <Pages.AddCommision />
          </MainContainer>
        }
      />

      <Route
        path="/settings/edit/:id"
        element={
          <MainContainer>
            <Pages.AddCommision />
          </MainContainer>
        }
      />

      <Route
        path="/wishlist-details"
        element={
          <MainContainer>
            <Pages.WishlistPropertyDetails />
          </MainContainer>
        }
      />
      <Route
        path="/user-chat-details/:userId/:id"
        element={
          <MainContainer>
            <Pages.userChatInboxDetails />
          </MainContainer>
        }
      />
      <Route
        path="/user-email-details/:userId"
        element={
          <MainContainer>
            <Pages.UserEmailInboxDetails />
          </MainContainer>
        }
      />
      <Route
        path="/manage-enqueries"
        element={
          <MainContainer>
            <Pages.ManageEnqeries />
          </MainContainer>
        }
      />

      <Route
        path="/manage-Order"
        element={
          <MainContainer>
            <Pages.ManageOrders />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Order/details/:_id"
        element={
          <MainContainer>
            <Pages.CustomerOrderDetails />
          </MainContainer>
        }
      />
      {/* <---------------Product Details----------------> */}
      <Route
        path="/manage-products"
        element={
          <MainContainer>
            <Pages.ManageProduct />
          </MainContainer>
        }
      />
      <Route
        path="/manage-products/edit/:id"
        element={
          <MainContainer>
            <Pages.AddProduct />
          </MainContainer>
        }
      />
      <Route
        path="/manage-products/add"
        element={
          <MainContainer>
            <Pages.AddProduct />
          </MainContainer>
        }
      />
      <Route
        path="/manage-products/details/:_id"
        element={
          <MainContainer>
            <Pages.ProductDetails />
          </MainContainer>
        }
      />
      {/* <---------------Product Details end----------------> */}

      {/* <---------------  ManageSubAdmin start----------------> */}
      <Route
        path="/manage-subadmin"
        element={
          <MainContainer>
            <Pages.ManageSubAdmin />
          </MainContainer>
        }
      />

      <Route
        path="manage-subadmin/edit/:_id"
        element={
          <MainContainer>
            <Pages.AddSubAdmin />
          </MainContainer>
        }
      />
      <Route
        path="/manage-subadmin/add"
        element={
          <MainContainer>
            <Pages.AddSubAdmin />
          </MainContainer>
        }
      />
      {/* <---------------  ManageSubAdmin start----------------> */}

      <Route
        path="/manage-Customer-Vendor-Support"
        element={
          <MainContainer>
            <Pages.ManageSupport />
          </MainContainer>
        }
      />
      {/* <---------------  ManageSubAdmin end----------------> */}
      {/* <---------------Manage Banners----------------> */}
      <Route
        path="/manage-Banners"
        element={
          <MainContainer>
            <Pages.ManageBanners />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Banners/edit/:_id"
        element={
          <MainContainer>
            <Pages.AddProduct />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Banners/add"
        element={
          <MainContainer>
            <Pages.ManageProduct />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Banners/details/:_id"
        element={
          <MainContainer>
            <Pages.ProductDetails />
          </MainContainer>
        }
      />
      {/* <---------------Manage Banners end----------------> */}

      {/* <---------------Manage chats----------------> */}
      <Route
        path="/manage-chats"
        element={
          <MainContainer>
            <Pages.ManageChats />
          </MainContainer>
        }
      />
      <Route
        path="/manage-chats/edit/:_id"
        element={
          <MainContainer>
            <Pages.AddProduct />
          </MainContainer>
        }
      />
      <Route
        path="/manage-chats/add"
        element={
          <MainContainer>
            <Pages.ManageProduct />
          </MainContainer>
        }
      />
      <Route
        path="/manage-chats/details/:_id"
        element={
          <MainContainer>
            <Pages.userChatInboxDetails />
          </MainContainer>
        }
      />
      {/* <---------------Manage chats end----------------> */}
      {/* <---------------Manage Payments----------------> */}
      <Route
        path="/manage-Payments"
        element={
          <MainContainer>
            <Pages.ManagePayments />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Payments/edit/:_id"
        element={
          <MainContainer>
            <Pages.AddProduct />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Payments/add"
        element={
          <MainContainer>
            <Pages.ManageProduct />
          </MainContainer>
        }
      />
      <Route
        path="/manage-Payments/details/:_id"
        element={
          <MainContainer>
            <Pages.PaymentDetails />
          </MainContainer>
        }
      />
      <Route
        path="/manage-quotes"
        element={
          <MainContainer>
            <Pages.ManageQuotes />
          </MainContainer>
        }
      />
      <Route
        path="/quote-chat"
        element={
          <MainContainer>
            <Pages.QuotesChatDetails />
          </MainContainer>
        }
      />
      <Route
        path="/manage-return-exchange"
        element={
          <MainContainer>
            <Pages.ManageReturnExchange />
          </MainContainer>
        }
      />
      <Route
        path="/manage-return-exchange/details/:id"
        element={
          <MainContainer>
            <Pages.ReturnExchangeDetails />
          </MainContainer>
        }
      />
      {/* <---------------Manage Paymentss end----------------> */}
      <Route
        path="/manage-refunds"
        element={
          <MainContainer>
            <Pages.ManageRefunds />
          </MainContainer>
        }
      />

      <Route path="/privacy-policy" element={<Pages.PrivacyPolicy />} />
    </Routes>
  );
};

export default Routing;
